import {useContext} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {PartnerContext} from '../PartnerContexts'

const AddUserModalHeader = () => {
  const {closeAddUserModal} = useContext(PartnerContext)

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Agregar Usuario</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => closeAddUserModal()}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export {AddUserModalHeader}
